// option change option_input
$(document).on("change", ".option_input", function () {
  let optionName = "";
  var template = $(".template-name").val();

  $("input:radio.option_input:checked").each(function (e) {
    optionName += e != 0 ? "-" : "";
    optionName += $(this).val();
  });

  $(".variant_selector option").each(function () {
    var txt = $.trim($(this).text());
    if (txt == optionName) {
      $(this).parent().val($(this).val());
      var vid = $(this).val();
      $(".product_id").val(vid);

      var id = $(".plan_input:checked").val();
      var subs = $(".select-delivery-time option:selected").val();
      var price = $(this).data("price");
      var compare = $(this).data("compare");
      var stock = $(this).data("stock");
      var rate = $(".plan_input:checked").data("rate");
      var bottle = $(".variant_selector option:selected").data("id");

      if (stock) {
        $(".add-to-cart-btn").removeClass("soldout").text("Add To Cart");
      } else {
        $(".add-to-cart-btn").addClass("soldout").text("Sold Out");
      }
      
      if((template == 'calm-legs') || (template == 'gummies')) {
        option_change(id, subs, price, compare, rate, bottle, template);
      }
    }
  });
});

// variant option
$(document).on("click", ".variant_option", function () {
  var vid = $(this).val();
  $(".product_id").val(vid);
  var template = $(".template-name").val();
  let variantName = $(this).data("name");

  $(".variant_selector option").each(function () {
    var txt = $.trim($(this).text());
    if (txt == variantName) {
      $(this).parent().val($(this).val());

      var id = $(".plan_input:checked").val();
      var subs = $(".select-delivery-time option:selected").val();
      var price = $(this).data("price");
      var compare = $(this).data("compare");
      var stock = $(this).data("stock");
      var rate = $(".plan_input:checked").data("rate");
      var bottle = $(".variant_selector option:selected").data("id");
      if (stock) {
        $(".add-to-cart-btn").removeClass("soldout").text("Add To Cart");
      } else {
        $(".add-to-cart-btn").addClass("soldout").text("Sold Out");
      }
      option_change(id, subs, price, compare, rate, bottle, template);
    }
  });
});

$(document).ready(function () {
  $(document).on("change", ".plan_input", function () {
    $(this).parent().addClass("active").siblings().removeClass("active");
    var id = $(this).val();
    var subs = $(".select-delivery-time option:selected").val();
    var price = $(".variant_selector option:selected").data("price");
    var compare = $(".variant_selector option:selected").data("compare");
    var bottle = $(".variant_selector option:selected").data("id");
    var rate = $(this).data("rate");
    var template = $(".template-name").val();

    if (id == 1) {
      $(".delivary-frequency").show();
    } else {
      $(".delivary-frequency").hide();
    }

    option_change(id, subs, price, compare, rate, bottle, template);
  });

  $(document).on("change", ".select-delivery-time", function () {
    var subs = $(this).val();
    var text = $(this).text();
    $("#selling_plan").val(subs);
    $(".delivary-frequency").text(text);
  });

  $(document).on("change", ".variant_selector", function () {
    var id = $(".plan_input:checked").val();
    var subs = $(".select-delivery-time option:selected").val();
    var price = $("option:selected", this).data("price");
    var compare = $("option:selected", this).data("compare");
    var rate = $(".plan_input:checked").data("rate");
    var bottle = $("option:selected", this).data("id");
    var template = $(".template-name").val();

    option_change(id, subs, price, compare, rate, bottle, template);
  });
});

function option_change(id, subs, price, compare, rate, bottle, template) {
  if (template == "main") {
    var subSave_1 = "Save $5";
    var subSave_2 = "Save $17";
    var subSave_3 = "Save $45";
  } else if (template == "calm-legs") {
    var subSave_1 = "Save 10%";
    var subSave_2 = "Save $10";
    var subSave_3 = "Save $30";
  } else if (template == "relief") {
    var subSave_1 = "Save $5";
    var subSave_2 = "Save $17";
    var subSave_3 = "Save $40";
  } else if (template == "new") {
    var subSave_1 = "Save $10";
    var subSave_2 = "Save $10";
    var subSave_3 = "Save $30";
  }

  if (
    template == "main" ||
    template == "burner" ||
    template == "calm-legs" ||
    template == "new"
  ) {
    if (bottle == 1) {
      $(".fixed-discount").text(subSave_1);
    } else if (bottle == 2) {
      $(".fixed-discount").text(subSave_2);
    } else if (bottle == 3) {
      $(".fixed-discount").text(subSave_3);
    }
  }

  if (id == 1) {
    $("#selling_plan").val(subs);
    if (template == "main") {
      $("#save_1").text("14");
      $("#save_2").text("19");
    } else if (template == "relief") {
      $("#save_1").text("30");
      $("#save_2").text("35");
    } else if (template == "oil") {
      if (bottle == 1 || bottle == 7) {
        $("#save_1").text("15");
        $("#save_2").text("20");
        $(".fixed-discount").text("Save $5");
      } else if (bottle == 2 || bottle == 8) {
        $("#save_1").text("15");
        $("#save_2").text("20");
        $(".fixed-discount").text("Save $15");
      } else if (bottle == 3 || bottle == 9) {
        $("#save_1").text("15");
        $("#save_2").text("20");
        $(".fixed-discount").text("Save $40");
      } else if (bottle == 4 || bottle == 10) {
        $(".fixed-discount").text("Save $10");
      } else if (bottle == 5 || bottle == 11) {
        $("#save_1").text("15");
        $("#save_2").text("28");
        $(".fixed-discount").text("Save $27");
      } else if (bottle == 6 || bottle == 12) {
        $("#save_1").text("15");
        $("#save_2").text("28");
        $(".fixed-discount").text("Save $72");
      }
    }

    $(".purchase-price-save").show();

    $("#price_1").text("($3.31 per meal)");
    $("#price_2").text("($3.17 per meal)");
    $("#price_3").text("($2.99 per meal)");

    if (compare > price) {
      $(".discount-price").text(currency + (compare * 0.01).toFixed(2));
    } else {
      $(".discount-price").text(currency + (price * 0.01).toFixed(2));
    }

    $(".reg-price").text(currency + (price * 0.01 * rate).toFixed(2));
    $(".total-value").show();
    $(".onetime_price").text(currency + (price * 0.01).toFixed(2));
    $(".subs_price").text(currency + (price * 0.01 * rate).toFixed(2));
  } else {
    $("#selling_plan").val("");
    if (template == "main") {
      $("#save_1").text("5");
      $("#save_2").text("10");
      $(".purchase-price-save").show();
    } else if (template == "relief") {
      $("#save_1").text("20");
      $("#save_2").text("25");
      // $('.purchase-price-save').show();
    } else if (template == "burner") {
      $(".purchase-price-save").hide();
    } else if (template == "oil") {
      if (bottle == 1 || bottle == 7) {
        $("#save_1").text("5");
        $("#save_2").text("10");
      } else if (bottle == 2 || bottle == 8) {
        $("#save_1").text("5");
        $("#save_2").text("10");
      } else if (bottle == 3 || bottle == 9) {
        $("#save_1").text("5");
        $("#save_2").text("10");
      } else if (bottle == 4 || bottle == 10) {
      } else if (bottle == 5 || bottle == 11) {
        $("#save_1").text("5");
        $("#save_2").text("20");
      } else if (bottle == 6 || bottle == 12) {
        $("#save_1").text("5");
        $("#save_2").text("20");
      }
    }

    $("#price_1").text("($3.99 per meal)");
    $("#price_2").text("($3.83 per meal)");
    $("#price_3").text("($3.61 per meal)");
    $(".reg-price").text(currency + (price * 0.01).toFixed(2));

    if (compare > price) {
      $(".total-value").show();
      $(".discount-price").text(currency + (compare * 0.01).toFixed(2));
      $(".onetime_price").text(currency + (price * 0.01).toFixed(2));
      $(".subs_price").text(currency + (price * 0.01 * rate).toFixed(2));
    } else {
      $(".discount-price").text("");
      $(".total-value").hide();
      $(".onetime_price").text(currency + (price * 0.01).toFixed(2));
      $(".subs_price").text(currency + (price * 0.01 * rate).toFixed(2));
    }
  }
}
